import { useCallback } from 'react';

import { usePsfSharePageData } from '#src/app/pages/psf/share/pageContext';
import { useQueryParamValue } from '#src/app/shared/hooks/location';
import {
	usePromotedTrackingData,
	useTrackPromotionShare as useTrackPromotionShareBase,
} from '#src/app/shared/hooks/promotion';

export function useTrackPromotionShare() {
	const trackPromotionShare = useTrackPromotionShareBase();
	const {
		data: {
			petition: { id },
		},
	} = usePsfSharePageData();
	const queryPromotionToken = useQueryParamValue('pt');
	const [localStoragePromotedData] = usePromotedTrackingData(id);

	return useCallback(async () => {
		const token = queryPromotionToken || localStoragePromotedData?.token;
		const placement = localStoragePromotedData?.placement;
		const algorithm = localStoragePromotedData?.algorithm;

		if (!token) return undefined;

		return trackPromotionShare({ token, placement, algorithm }, { silent: true });
	}, [trackPromotionShare, queryPromotionToken, localStoragePromotedData]);
}
